import { Component, OnInit, HostListener } from '@angular/core';

import { DocumentService } from '../../../services/documents/document.service';

@Component({
  selector: 'app-document-index',
  templateUrl: './document-index.component.html',
  styleUrls: ['./document-index.component.css'],
})
export class DocumentIndexComponent implements OnInit {
  count: number = 0;

  documents: Array<any> = [];

  search_options: any = {
    per_page: 30,
  };

  search_params: any = {
    page: 1,
    per_page: 30,
    tag_scope: 'All',
  };

  searching: boolean = false;

  constructor(private documentService: DocumentService) {}

  // Component Lifecycle Events

  ngOnInit() {
    this.content_sidebar_scroll();
    this.search_height_maintainer();
    this.searching = true;
    this.documentService.getSearchOptions().then((response_json) => {
      this.search_options = response_json;
      this.search_params.per_page = response_json.per_page;
      this.search();
    });
  }

  // Event Listeners

  @HostListener('window:scroll', ['$event'])
  window_scroll(event: Event) {
    this.content_sidebar_scroll();
    this.search_height_maintainer();
  }

  @HostListener('window:resize', ['$event'])
  window_resize(event: Event) {
    this.content_sidebar_scroll();
    this.search_height_maintainer();
  }

  // Component Methods

  clearSearch() {
    this.search_params = {
      tag_scope: 'All',
    };
  }

  search(pageNumber: any = null) {
    if (pageNumber) this.search_params.page = pageNumber.page;
    this.searching = true;
    this.documentService.getDocuments(this.search_params).then((response_json) => {
      this.documents = response_json.documents;
      this.count = response_json.count;
      this.searching = false;
    });
  }

  // Functions for UI manipulation using vanilla JS or jQuery

  content_sidebar_scroll() {
    var content_main = document.getElementById('content-main');
    var content_sidebar = document.getElementById('content-sidebar');
    var sidebar_height = window.innerHeight;
    if (content_sidebar && content_main) {
      if (content_main.getBoundingClientRect().top > 19) {
        content_sidebar.style.position = 'absolute';
        content_sidebar.style.top = content_main.offsetTop + 10 + 'px';
        sidebar_height -= content_main.getBoundingClientRect().top + 40;
        //console.log('greater ' + matter_sidebar.style.top);
      } else {
        content_sidebar.style.position = 'fixed';
        content_sidebar.style.top = '20px';
        sidebar_height -= content_sidebar.getBoundingClientRect().top + 40;
        //console.log('lesser ' + matter_sidebar.style.top);
      }
      if (content_sidebar.clientHeight != sidebar_height) content_sidebar.style.height = sidebar_height + 'px';
    }
  }

  search_height_maintainer() {
    var content_sidebar = document.getElementById('content-sidebar');
    var content_search = document.getElementById('search-form');
    if (content_sidebar && content_search) {
      var search_height = content_sidebar.clientHeight - 81;
      if (search_height > 0) content_search.style.height = search_height + 'px';
      else content_search.style.height = '0px';
    }
  }
}
